var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getInfor && !_vm.isMobile)?_c('PCIndustryExperience',{attrs:{"json":_vm.json}}):(_vm.getInfor && _vm.isMobile)?_c('MobIndustryExperience',{attrs:{"json":_vm.json}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }